import React, { useMemo } from 'react';
import { CarTrailerChecklistType, ChecklistDataEntry, StudentChecklistValue } from './types';
import { useTranslation } from 'react-i18next';
import ChecklistValueCell from './ChecklistValueCell';
import { createColumnHelper } from '@tanstack/react-table';
import Table from './Table';

type CarTrailerChecklistDataEntry = ChecklistDataEntry & {
	healthDeclaration: StudentChecklistValue;
	practicalExam: StudentChecklistValue;
};

const columnHelper = createColumnHelper<CarTrailerChecklistDataEntry>();

const CarTrailerChecklist = ({ checklist }: { checklist: CarTrailerChecklistType }) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('student.lastName', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('student.firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('healthDeclaration', {
				header: 'Gezondheidsverklaring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('practicalExam', {
				header: 'Praktijkexamen',
				cell: ChecklistValueCell,
			}),
		];
	}, []);

	const data = useMemo(() => {
		return checklist.checklists.map((entry) => ({
			student: entry.student,
			healthDeclaration: entry.values.find(
				(value) => value.option.name === 'Gezondheidsverklaring',
			) || { value: null },
			practicalExam: entry.values.find((value) => value.option.name === 'Praktijkexamen') || {
				value: null,
			},
		}));
	}, [checklist]);

	return <Table data={data} columns={columns} />;
};

export default CarTrailerChecklist;
